export default __webpack_public_path__ + "static/media/heidiHeadshot.69464905.jpg";